module.exports = __webpack_public_path__ + "img/question.2fdb3b98.svg";